import React, { useContext, useState } from 'react';
import { SetupDataPageTemplate } from '../../../components/setup-pages/SetupDataPageTemplate';
import { Form } from "react-jsonschema-form-validation";
import { pathRoot, getOptionsElements } from '../AsbestosHistory';
import { DiseaseGroupContext } from '../../../contexts/diseaseGroupContext';

export function Page3({ asbestosHistory }) {

	const schema = {
		type: "object"
	};

	const armedForcesTypeOptionsData = [{
		label: "Army",
		value: 0
	},
	{
		label: "Royal Navy",
		value: 1
	},
	{
		label: "Air Force",
		value: 2
	},
	{
		label: "Other",
		value: 3
	}];

	const lengthOfServiceOptionsData = [{
		label: "Less than 5 years",
		value: 0
	}, {
		label: "5-10 years",
		value: 1
	}, {
		label: "10-15 years",
		value: 2
	}, {
		label: "15-20 years",
		value: 3
	}, {
		label: "More than 20 years",
		value: 4
	}];

	const [armedForcesType, setArmedForcesType] = useState(asbestosHistory.armedForcesType ?? null);
	const [lengthOfService, setLengthOfService] = useState(asbestosHistory.lengthOfService ?? null);

	const hideNext = () => {
		return armedForcesType === null || lengthOfService === null;
	};

	const updateUserSettings = () => {
		asbestosHistory.armedForcesType = armedForcesType;
		asbestosHistory.lengthOfService = lengthOfService;
	};

	const headerDetails = {
		title: "Asbestos History",
		currentPage: 3,
		pageCount: 4
	};

	const {theme} = useContext(DiseaseGroupContext);

	return (<><SetupDataPageTemplate headerDetails={headerDetails} backTo={`${pathRoot}/2`} nextTo={`${pathRoot}/4`} onClickBack={updateUserSettings} onClickNext={updateUserSettings} hideNext={hideNext()}>
		
			<Form schema={schema}>
				<p className={"text-lg sm:text-xl font-bold mb-6"}>Which of the armed forces did you serve in?</p>
				<div className={"mb-6 sm:mb-9"}>
					{getOptionsElements(armedForcesTypeOptionsData, "armedForcesType", armedForcesType, setArmedForcesType, theme)}
				</div>
				<p className={"text-lg sm:text-xl font-bold mb-6"}>What was your length of service?</p>
				<div>
					{getOptionsElements(lengthOfServiceOptionsData, "lengthOfService", lengthOfService, setLengthOfService, theme)}
				</div>
			</Form>
		
	</SetupDataPageTemplate></>);
}
